import { useCallback } from 'react'
import { trackUserEvent } from '@vend/utilities'
import { useAppSelector } from '../../state/hooks'
import {
  selectCurrentSale,
  selectLineItems,
} from '../../state/slices/currentSale/currentSaleSlice'
import { WEB_REGISTER } from '../web-register.constant'
import { useRegisterManager } from '../../ng-compat/hooks'
import { getBasketSize } from '../../functions/lineItem'
import { useSpecialOrderProduct } from './useSpecialOrderProduct'

/**
 * Hook to track special order event
 */
export const useSpecialOrderUBE = () => {
  const sale = useAppSelector(selectCurrentSale)
  const lineItems = useAppSelector(selectLineItems)
  const isSpecialOrderProduct = useSpecialOrderProduct()
  const registerManager = useRegisterManager()

  const trackSpecialOrderEvent = useCallback(() => {
    const specialOrderLineItems = lineItems.filter(isSpecialOrderProduct)

    if (specialOrderLineItems.length === 0) {
      return
    }

    const ubeLineItems = specialOrderLineItems.map(lineItem => ({
      id: lineItem.localId,
      productId: lineItem.product.id,
      quantity: lineItem.quantity,
      price: lineItem.price,
      total: registerManager.isTaxInclusive()
        ? lineItem.totals.inclusivePrice
        : lineItem.totals.exclusivePrice,
    }))

    // total quantity of all line items in the sale
    const basketSize = getBasketSize(lineItems)

    const ubeData = {
      id: sale.localId,
      saleTotal: sale.finals.inclusivePrice,
      itemCount: basketSize,
      specialOrderLineItems: ubeLineItems,
    }

    trackUserEvent(WEB_REGISTER.DISPLAY_NAME, 'Special Order Products', ubeData)
  }, [sale, lineItems, isSpecialOrderProduct, registerManager])

  return trackSpecialOrderEvent
}
